import React from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import "@/App.css";
import { Toaster } from "sonner";

import { AuthProvider } from "@/context/AuthContext";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";

import HomePage from "@/pages/HomePage";
import InventoryPage from "@/pages/InventoryPage";
import EquipmentDetailPage from "@/pages/EquipmentDetailPage";
import FinancingPage from "@/pages/FinancingPage";
import ContactPage from "@/pages/ContactPage";
import AboutPage from "@/pages/AboutPage";
import AdminLoginPage from "@/pages/AdminLoginPage";
import AdminDashboard from "@/pages/AdminDashboard";

function Layout({ children }) {
  const location = useLocation();
  const isAdmin = location.pathname.startsWith("/admin");
  return (
    <>
      {!isAdmin && <Header />}
      <main>{children}</main>
      {!isAdmin && <Footer />}
    </>
  );
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Layout>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/inventory" element={<InventoryPage />} />
              <Route path="/equipment/:id" element={<EquipmentDetailPage />} />
              <Route path="/financing" element={<FinancingPage />} />
              <Route path="/about" element={<AboutPage />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="/admin/login" element={<AdminLoginPage />} />
              <Route path="/admin" element={<AdminDashboard />} />
            </Routes>
          </Layout>
          <Toaster
            position="top-right"
            theme="dark"
            toastOptions={{
              style: {
                background: "#141415",
                border: "1px solid #27272A",
                color: "#fff",
                borderRadius: 0,
                fontFamily: "JetBrains Mono, monospace",
                fontSize: "12px",
                textTransform: "uppercase",
                letterSpacing: "0.1em",
              },
            }}
          />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
